import Layout from '../components/Layout';
import './VironNotice.css';
import { React, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoModal from './CryptoPopUp';
import CryptoPaymentModal from './CryptoPaymentPopUp';
import PreLaunchModal from './PreLaunchPopup';

// import Logo from '../../public/assets/';// Place your VIRON logo in the same folder
import { API_BASE_URL } from './config';
import CryptoPaymentSubmittedPopUp from './CryptoPaymentSubmittedPopUp';

function TxcAccountSetup() {
    let userId = localStorage.getItem('userId');
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        user_id: '',
        btc_txn: '',
        txc_txn: '',
        usdc_txn: ''
    });
    const [isModalOpen, setModalOpen] = useState(false);
    const [isModalPaymentOpen, setModalOpenPayment] = useState(false);
    const [isModalPaymentSubmittedOpen, setModalOpenSubmittedPayment] = useState(false);
    const [isModalPreLaunchOpen, setModalOpenPreLaunch] = useState(false);
    const submitSingleTxn = async (data) => {
        // at least one value will be there
        if (!data.btc_txn && !data.txc_txn && !data.usdc_txn) {
            alert('Please enter valid  transaction ID.');
            return;
        }
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE_URL}/payment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(data),
            });

            const result = await res.json();
            if (res.ok) {
                alert(`Your crypto payment has been submitted!\nPlease click OK for an important NOTIFICATION.`);
                setFormData({
                    user_id: '',
                    btc_txn: '',
                    txc_txn: '',
                    usdc_txn: ''
                });
                navigate('/member/paymentlandingpage');
            } else {
                alert('Error: ' + result.message);
            }
        } catch (err) {
            alert('Failed to submit payment.');
            console.error(err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let data = {
            user_id: userId,
            btc_txn: formData.btc_txn,
            txc_txn: formData.txc_txn,
            usdc_txn: formData.usdc_txn
        };

        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE_URL}/payment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(data),
            });

            const result = await res.json();
            if (res.ok) {
                alert(`Your crypto payment has been submitted!\nPlease click OK for an important NOTIFICATION.`);
                setFormData({
                    user_id: '',
                    btc_txn: '',
                    txc_txn: '',
                    usdc_txn: ''
                });
                navigate('/member/paymentlandingpage');
            } else {
                alert('Error: ' + result.message);
            }
        } catch (err) {
            alert('Failed to submit payment.');
            console.error(err);
        }
    };
    return (
        <Layout>
            <div className='container'>
                <div className="row">
                    <div className='col'>
                        <div>
                            <p className='text-center mb-0'></p>
                            <h3 className='text-red text-center paymentArea pt-20'><strong>PAYMENT AREA.</strong></h3>
                            <p className='text-center mb-0 mt-0'><strong>::: ::: :::</strong></p>
                            {/* <p className='text-center mt-0 mb-0'>During Pre-Launch, we are <u>directly</u> accepting cryptocurrency payments:<br />Bitcoin (<strong>BTC</strong>),<br />Ethereum (<strong>ETH</strong>),<br /><strong>USDT</strong> (<em>Tron Network</em>).</p> 
                            <p className='text-center text-red mb-0'>To complete your <strong>VIRON Home-Business</strong> (&ldquo;<strong>VHB</strong>&rdquo;),<br />please send your Cryptocurrency payment to:</p> */}
                            <p className="text-red text-center">To complete your <b><u>TEXITcoin (TXC) ACCOUNT Set-Up</u></b> please send your <b><u>$995</u></b> payment to one of the following accepted Cryptocurrency wallets of VIRON below.</p>
                            <hr className='mt-10 mb-10' />
                            {/* <p className='text-center text-light-blue mt-0 mb-0' style={{ fontSize: 20, lineHeight: 1.5 }}><strong>VIRON ACCOUNTING</strong><br />
                                <i>Accepted Cryptocurrency Wallets:</i><br />
                                <strong>(USDC-ETH is preferred)</strong></p>
                            <hr className='mt-10 mb-0' /> */}
                            <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-10' src="https://viron.network/member/assets/usdc_image.png" alt="usdc_image" width="100px" /><img className='mt-10' src="https://viron.network/member/assets/USDCscanner.png" alt="USDCscanner" width="125px" /></div>
                            <p className='text-center'><strong>USDC</strong> (ETH Network): </p>
                            <p className='text-center no_wordwrap'>0x0E83379C21dc46B6e989A316a07E503733cc53c8</p>
                            <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-40' src="https://viron.network/member/assets/bitcoin.png" alt="bitcoin" width="100px" /><img className='mt-40' src="https://viron.network/member/assets/BTCscanner.png" alt="BTCscanner" width="125px" /></div>
                            <p className='text-center'><strong>BitCoin (BTC):</strong></p>
                            <p className='text-center no_wordwrap'>1E92bqvm6JQ2DYAkHzjpdjRSWFDzx2dqk7</p>
                            <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-40' src="https://viron.network/member/assets/texitcointpayment.png" alt="texitCoinScanner" width="100px" /><img className='mt-40' src="https://viron.network/member/assets/texitCoinScanner.png" alt="texitCoinScanner" width="125px" /></div>
                            {/* <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-20' src="assets/texitcointpayment.png" alt="texitCoinScanner" width="100px" /><img className='mt-20' src="assets/texitCoinScanner.png" alt="texitCoinScanner" width="125px" /></div> */}
                            <p className='text-center'><strong>TEXITcoin (TXC):</strong></p>
                            <p className='text-center no_wordwrap'>txc1qedgw8xpy25auqanf4czqaew7qresnlgfwz0ehn</p>
                            {/* <p className='text-center'><strong>Ethereum (ETH): </strong></p>
                            <p className='text-center no_wordwrap'>0x0E83379C21dc46B6e989A316a07E503733cc53c8</p>
                            <p className='text-center'><strong>USDT (Tron) Network: </strong></p>
                            <p className='text-center pb-10 mb-0 no_wordwrap'>TEtVu6h7Fr6u8KCLXac8ywZqgdrguPzS4Q</p> */}
                            <p className='text-center mt-0'><strong>:::</strong></p>
                            <p><strong className='text-red'>NOTE: When you make your crypto payment, please make sure to <u>copy</u> your Crypto <u>Transaction ID #</u>. Then <u>paste</u> or enter it in the corresponding field below.</strong><i></i></p>
                            {/* <p className='text-center text-red'><strong>FURTHER NOTE: If you&rsquo;re using the Exodus crypto wallet, please input your <u>VIRON Username</u> (into the Exodus: Transaction / "Memo/Note" field) <u>to help us locate and identify your payment as quickly as possible</u>.</strong></p> */}
                            <div className="transaction-form-container">
                                <div className="crypto-form">
                                    {[
                                        { id: 'usdc_txn', label: 'USDC Blockchain Transaction ID#', placeholder: "Enter your USDC (ETH network) Blockchain Transaction ID#" },
                                        { id: 'btc_txn', label: 'BTC Blockchain Transaction ID#', placeholder: "Enter your BTC Blockchain Transaction ID#" },
                                        { id: 'txc_txn', label: 'TXC Blockchain Transaction ID#', placeholder: "Enter your TXC Blockchain Transaction ID#" },
                                    ].map(({ id, label, placeholder }) => (
                                        <form
                                            key={id}
                                            className="form-row"
                                            style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}
                                            onSubmit={e => {
                                                e.preventDefault();
                                                // Only submit the current field
                                                const data = {
                                                    user_id: userId,
                                                    usdc_txn: id === 'usdc_txn' ? formData.usdc_txn : '',
                                                    btc_txn: id === 'btc_txn' ? formData.btc_txn : '',
                                                    txc_txn: id === 'txc_txn' ? formData.txc_txn : '',
                                                };
                                                submitSingleTxn(data);
                                            }}
                                        >
                                            <label htmlFor={id} style={{ minWidth: 220 }}>{label}</label>
                                            <input
                                                type="text"
                                                id={id}
                                                name={id}
                                                value={formData[id]}
                                                onChange={handleChange}
                                                placeholder={placeholder}
                                                style={{ flex: 1, marginRight: 12 }}
                                            />
                                            <button type="submit">Submit</button>
                                        </form>
                                    ))}
                                </div>
                            </div>

                            {/* <p className="text-red"><strong>:::</strong></p> */}
                            <p className=''>When you send your Transaction ID# by clicking on “<b>Submit</b>” above, <u><b>the VIRON Admins will be notified and will escalate the process for you accordingly.</b></u> </p>
                            {/* <p>When your TXC account is confirmed, you can relax, sit back, and watch your business grow.</p> */}
                            {/* <p>We will further notify you when your TXC account has been set up and confirmed.</p> */}

                            <hr className='mt-0 mb-20' />
                            <p className='text-center text-red mt-30 pb-10'><b>! CRITICAL</b><br /><a style={{ cursor: 'pointer' }} onClick={() => setModalOpenSubmittedPayment(true)}><strong><u>AFTER YOUR CRYPTO PAYMENT IS SUBMITTED – CLICK HERE</u></strong></a></p>
                            <CryptoPaymentSubmittedPopUp isOpen={isModalPaymentSubmittedOpen} onClose={() => setModalOpenSubmittedPayment(false)} />
                            <p className='text-center mb-0'><strong>TXC ACCOUNT CREATION - IS AUTOMATIC</strong></p>
                            <p className='mt-0'>After your payment is made, the setup of your TXC account will be completed on your behalf. <span className='text-red'><strong>EVERYTHING WILL BE HANDLED FOR YOU. YOU WILL RECEIVE PROPER NOTICE ACCORDINGLY AT EACH STEP.</strong></span> <i>*Once your account is correctly established, you will simply log into your TXC account, change your password, and become the perpetual Owner!</i></p>
                            <p className='text-center'><b><i>-The VIRON Administration</i></b></p>
                            <p className='text-center text-red mt-30 pb-10'><a style={{ cursor: 'pointer' }} onClick={() => setModalOpenPayment(true)}><strong><u>NEED HELP WITH CRYPTO PAYMENT?  CLICK HERE</u></strong></a></p>
                            <CryptoPaymentModal isOpen={isModalPaymentOpen} onClose={() => setModalOpenPayment(false)} />
                            <p className='text-center text-red pb-5'><a style={{ cursor: 'pointer' }} onClick={() => setModalOpen(true)}><u><strong>CRYPTO PAYMENT PREFERRED - WHY? CLICK HERE</strong></u></a></p>
                            <CryptoModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
                            {/* <p className='text-center text-blue mt-0'>FYI: *STRIPE payment method, coming soon.</p>
                            <p className='text-center text-blue'>&amp;</p>
                            <p className='text-center text-blue'>*Automated Crypto-Currency Payment Processing by TYGA-Pay, coming soon.</p>
                            <p className='text-center pt-20'><strong><em>-The VIRON Administration</em></strong></p> */}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default TxcAccountSetup;
